import {gql} from 'apollo-angular';

export const GET_ROOKIE_SCHOOLS = gql`
  query GetRookieSchools($districtId: Int!) {
    rookieSchools(districtId: $districtId) {
      id
      schoolName
      timeSlot {
        id
        state
        name
        openAt
        closeAt
      }
      schoolClasses{
        schoolId
        schoolClassId
        schoolClassName
      }
    }
  }
`;
